/**
 * Vuex/mutations用。値を渡すと対象stateを値に上書きする関数を返す。
 * @param {String} property 対象となるstateの名称
 * @return {Function}
 */
export const set = property => (state, payload) => (state[property] = payload)

/**
 * Vuex/Mutations用。オブジェクト形式で{アップデートしたいプロパティ名: 値}を渡すとオブジェクト形式のstateの対象プロパティだけをアップデートする関数を返す。
 * @param {String} property 対象となるstateの名称
 * @return {Function}
 */
export const setProp = property => (state, payload) => (state[property] = { ...state[property], ...payload })

/**
 * Vuex/mutations用。呼び出すと対象stateの値(Boolean)をトグルする関数を返す。
 * @param {String} property 対象となるstateの名称
 * @return {Function}
 */
export const toggle = property => state => (state[property] = !state[property])
